/* eslint-disable quote-props */
/* eslint-disable max-len */
import Question from '../../../models/Question';
import SlotTypes from '../../../models/SlotTypes';
import QuestionType from '../../../models/enums/QuestionType';
import SlotUnit from '../../../models/enums/SlotUnit';
import { defaultBasedAverage } from '../../../models/SlotHelp.spec';

/* eslint-disable camelcase */

const question_gov_014: Question = {
  id: 'gov-014-montants-habitant-programmes',
  oldId: '14',
  title: 'Montant investis par habitants pour ces programmes',
  number: '1.14',
  frequency: 1,
  type: QuestionType.INDICATOR,
  description: ['Montant total investit dans les programmes de conservation ou sensibilisation (calculé en $ par habitants)'],
  slots: [
    {
      type: SlotTypes.REPEATER,
      items: [''],
      data: ['0'],
      repeaterFields: [
        {
          label: 'Nom du programme',
          slug: 'name',
          width: '40%',
        },
        {
          label: 'Montant alloué',
          slug: 'amount',
          width: '40%',
          type: 'number',
        },
        {
          label: 'Année',
          slug: 'year',
          width: '20%',
        },
      ],
      scoreCalculatedLater: true,
      optional: false,
      scoringFct: (data:number) => {
        if (data >= 100) return 4;
        if (data >= 75) return 3;
        if (data >= 50) return 2;
        if (data >= 25) return 1;
        return 0;
      },
      score: '0',
      maxScore: 4,
      help: defaultBasedAverage,
      unit: SlotUnit.DOLLAR_PER_RESIDENT,
    },
  ],
};
const question_gov_014__v3: Question = {
  ...question_gov_014,
  number: '1.11',
};

export const question_gov_014_v2: Question = question_gov_014;
export const question_gov_014_v3: Question = question_gov_014__v3;
